import Vue from 'vue';
import Router from 'vue-router';
import { routes } from './routes';

Vue.use(Router);

const router = new Router({
    // mode: 'history',
    routes
});

import { updateGuard } from './guards';

router.beforeEach(updateGuard);

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js